<template>
<div class="iot-card card" @click="replaceInfo(info)">
  <VImg class="img" :attachment-id="info.attmIds"/>
  <div class="info">
    <div >
      <div  class="title" v-html="info.name"></div>
      <div class="text-overflow2 text" v-html="info.discription"></div>
    </div>
    <div>
      <div><span>{{typeName}}</span><span>{{info.updateTime.slice(0,10)}}更新</span></div>
      <a-button @click.stop="open"><a-icon type="deployment-unit" class="icon"/>关系图谱</a-button>
    </div>
  </div>
</div>
</template>

<script>
import VImg from '@/components/VImg.vue'

export default{
  props: {
    info:{}
  },
  data(){
    return{}
  },
  components: {VImg},
  computed:{
    typeName(){
      if(this.info.type===3){
        return '开发板'
      }
      if(this.info.type===4){
        return 'SOC'
      }
      if(this.info.type===5){
        return '嵌入式0S'
      }
      if(this.info.type===6){
        return '硬件产品'
      }
    },
  },
  methods:{
    open(){
      this.$emit('openGraph')
    },
    replaceInfo(info) {
      if(info.type===3){
        this.$router.push(`/replace/productInfo/dev?id=${info.id}`);
      }
      if(info.type===4){
        this.$router.push(`/replace/productInfo/soc?id=${info.id}`);
      }
      if(info.type===5){
        this.$router.push(`/replace/productInfo/os?id=${info.id}`)
      }
      if(info.type===6){
        this.$router.push(`/replace/info?id=${info.id}`)
      }

    },
  }

}
</script>


<style scoped lang="scss">
.iot-card{
  padding: 24px;
  display: flex;
  cursor: pointer;
  height: 171px;
  border-bottom: 1px solid #EEEEEE;
  .img{
    display: block;
    width: 96px;
    height: 96px;
    margin-right: 12px;
  }
  .info{
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    >:first-child{
      >.title{
        font-weight: 400;
        font-size: 16px;
        color: #262626;
        line-height: 22px;
        margin-bottom: 0;
      }
      >text{
        font-weight: 400;
        font-size: 14px;
        color: #666666;
        line-height: 20px;
      }
    }
    >:nth-child(2){
      display: flex;
      justify-content: space-between;
      align-items: center;
      >:first-child{
        font-weight: 400;
        font-size: 14px;
        color: #999999;
        line-height: 20px;
        >:first-child{
          margin-right: 24px;
        }
      }
      >:last-child{
          color: #262626;
          .icon{
            color: #EA0B06;
          }
      }
    }
  }
}
</style>
